module.exports = __webpack_public_path__ + "img/a7.2d638304.jpg";